module.exports = __webpack_public_path__ + "img/logo.54bc4113.png";